import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import routes from "common/routes";
import { WorkoutsTableTab } from "../pages/WorkoutsPage/Vet/helper";
import ITab from "./Tab";

export const tabs: VetWorkoutsTab[] = [
  {
    name: "Requests",
    value: WorkoutsTableTab.REQUESTS,
    requestStatuses: [
      racehorse360.WorkoutRequestStatus.WORKOUT_REQUEST_STATUS_REQUESTED
    ],
    path: routes.workoutRequests.path,
    itemsPerPage: 12,
    additionalSelectedFields: [
      "pastWorkoutRequestsCount",
      "flag.flaggedBy.lastname",
      "flag.flaggedOn",
      "flag.priority",
      "horse.totalVetListsCount",
      "horse.activeVetListsCount",
      "horse.completedExamsWithNoteCount",
      "horse.flagOnTrack.flagOnTrackComment",
      "horse.hasActualFlagOnTrack",
      "horse.lastFivePastPerformances",
      "horse.lastFourWorkouts",
      "horse.lifetime.starts",
      "horse.lifetime.wins",
      "horse.lifetime.place",
      "horse.lifetime.show",
      "horse.lastExamNote.note",
      "horse.lastExamNote.createdBy.firstName",
      "horse.lastExamNote.createdBy.lastName",
      "horse.lastExamNote.createdOn",
      "horse.riskFactorShortDescriptions",
      "horse.riskFactorsCount",
      "horse.riskFactorScore"
    ]
  },
  {
    name: "Exams",
    value: WorkoutsTableTab.EXAMS,
    requestStatuses: [
      racehorse360.WorkoutRequestStatus.WORKOUT_REQUEST_STATUS_EXAM_PENDING
    ],
    examStatuses: [
      racehorse360.HorseExamStatus.HORSE_EXAM_STATUS_REQUESTED,
      racehorse360.HorseExamStatus.HORSE_EXAM_STATUS_IN_PROGRESS
    ],
    path: routes.workoutExams.path,
    itemsPerPage: 50,
    additionalSelectedFields: [
      "status",
      "isFlagged",
      "pastWorkoutRequestsCount",
      "flag.flaggedBy.lastname",
      "flag.flaggedOn",
      "flag.priority",
      "horse.totalVetListsCount",
      "horse.activeVetListsCount",
      "horse.riskFactorShortDescriptions",
      "horse.riskFactorsCount",
      "horse.riskFactorScore",
      "workoutExam.assignedUser.firstName",
      "workoutExam.assignedUser.lastName",
      "workoutExam.createdBy.firstName",
      "workoutExam.createdBy.lastName",
      "workoutExam.status"
    ]
  },
  {
    name: "Passed",
    value: WorkoutsTableTab.PASSED,
    requestStatuses: [
      racehorse360.WorkoutRequestStatus.WORKOUT_REQUEST_STATUS_APPROVED
    ],
    examStatuses: [racehorse360.HorseExamStatus.HORSE_EXAM_STATUS_COMPLETED],
    results: [racehorse360.HorseExamResult.HORSE_EXAM_RESULT_PASSED],
    path: routes.workoutPassed.path,
    itemsPerPage: 50,
    additionalSelectedFields: [
      "workoutExam.completedDate",
      "workoutExam.assignedUser.firstName",
      "workoutExam.assignedUser.lastName",
      "workoutExam.type"
    ]
  },
  {
    name: "Failed",
    value: WorkoutsTableTab.FAILED,
    requestStatuses: [
      racehorse360.WorkoutRequestStatus.WORKOUT_REQUEST_STATUS_DENIED
    ],
    examStatuses: [racehorse360.HorseExamStatus.HORSE_EXAM_STATUS_COMPLETED],
    results: [racehorse360.HorseExamResult.HORSE_EXAM_RESULT_FAILED],
    path: routes.workoutFailed.path,
    itemsPerPage: 50,
    additionalSelectedFields: [
      "workoutExam.assignedUser.firstName",
      "workoutExam.assignedUser.lastName",
      "workoutExam.completedDate"
    ]
  },
  {
    name: "Rejected",
    value: WorkoutsTableTab.REJECTED,
    requestStatuses: [
      racehorse360.WorkoutRequestStatus.WORKOUT_REQUEST_STATUS_REJECTED
    ],
    path: routes.workoutRejected.path,
    itemsPerPage: 12,
    additionalSelectedFields: [
      "rejectionNote.body",
      "rejectionNote.isImagingDiagnosticsRequired",
      "rejectionNote.updatedBy.firstName",
      "rejectionNote.updatedBy.lastName",
      "rejectionNote.updatedOn"
    ]
  }
];

export interface VetWorkoutsTab extends ITab<WorkoutsTableTab> {
  requestStatuses?: racehorse360.WorkoutRequestStatus[];
  examStatuses?: racehorse360.HorseExamStatus[];
  results?: racehorse360.HorseExamResult[];
  itemsPerPage: number;
  additionalSelectedFields: string[];
}
